// Websocket
/**
 * Echo exposes an expressive API for subscribing to channels and listening
 * for events that are broadcast by Laravel. Echo and event broadcasting
 * allows your team to easily build robust real-time web applications.
 */
// Websocket
window.io = require('socket.io-client');

import { reactive } from 'vue';
import Echo from 'laravel-echo';

let hostname = window.location.hostname;
let domain = hostname.split('.');
let sub = domain.length > 0 ? domain.shift() : '';
let ws, host;
let key = '5cae796f2f573abc2986446a48125b59';
let port = '6001';
const devcp = [
    //'www.laravel.cc',
    'cp.laravel.cc',
    'cp2.laravel.cc',
    'devcp.health-click.com.tw',
    'devcp2.health-click.com.tw',
    'hc.health-click.com.tw',
];
if (devcp.includes(hostname)) {
    port = '6002';
    key = '946c8c225ea2c63f68082d8aa1983f6d';
    ws = `https://devwww.health-click.com.tw:${port}`;
    //ws = `https://www.health-click.com.tw:${port}`;
} else {
    switch (sub) {
        case 'devwww':
        case 'devcp':
            port = '6002';
            host = 'devwww';
            key = '946c8c225ea2c63f68082d8aa1983f6d';
            break;
        default:
            host = 'www';
            break;
    }
    ws = `https://${[host].concat(domain).join('.')}:${port}`;
}

const state = reactive({
    connected: false,
});

export function Websocket() {

    const echo = new Echo({
        'broadcaster': 'socket.io',
        'host': ws, //default
        //'host': 'https://www.health-click.com.tw:6001', //master
        'key': key,
        'transports': ['websocket', 'polling'],
        'withoutInterceptors': true
    });
    return {
        state,
        echo,
    };
};

// window.Echo = new Echo({
//     'broadcaster': 'socket.io',
//     'host': ws, //default
//     //'host': 'https://www.health-click.com.tw:6001', //master
//     'key': key,
//     'transports': ['websocket', 'polling'],
//     'withoutInterceptors': true
// });

//window.EchoId = Echo.socketId;

//
